import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  ChatWidgetSettings,
  FALLBACK_SETTINGS,
  isChatWidgetAllowed,
  isInApp,
  isMobileViewport,
  setChatWidgetAllowed,
} from 'utils/chatWidget';

const TAWK_SRC = 'https://embed.tawk.to/6295313f7b967b1179920750/1g4bcgo25';

const loadTawk = (position: ChatWidgetSettings['position']) => {
  const w = window as any;
  w.Tawk_API = w.Tawk_API || {};
  // Tiene que estar antes de cargar el script; pisa la posición del panel.
  if (position) w.Tawk_API.customStyle = { visibility: position };
  const script = document.createElement('script');
  script.async = true;
  script.src = TAWK_SRC;
  script.charset = 'UTF-8';
  script.setAttribute('crossorigin', '*');
  document.head.appendChild(script);
};

// Se monta una vez, dentro del router.
const ChatWidget = () => {
  const { pathname } = useLocation();
  const [settings, setSettings] = useState<ChatWidgetSettings | null>(null);
  const [mobile, setMobile] = useState(isMobileViewport);

  useEffect(() => {
    fetch(`${import.meta.env.VITE_API_URL || ''}/api/settings/chat-widget`)
      .then((res) => (res.ok ? res.json() : FALLBACK_SETTINGS))
      .catch(() => FALLBACK_SETTINGS)
      .then((data: ChatWidgetSettings) => {
        setSettings(data);
        loadTawk(data.position);
      });

    const media = window.matchMedia('(max-width: 767px)');
    const onChange = () => setMobile(media.matches);
    media.addEventListener('change', onChange);
    return () => media.removeEventListener('change', onChange);
  }, []);

  useEffect(() => {
    if (!settings) return;
    const allowed = isChatWidgetAllowed(settings, pathname, mobile, isInApp());
    const w = window as any;
    // Antes de que cargue, hideWidget/showWidget no existen todavía.
    w.Tawk_API.onLoad = () => setChatWidgetAllowed(allowed);
    setChatWidgetAllowed(allowed);
  }, [settings, pathname, mobile]);

  return null;
};

export default ChatWidget;
